import { render } from "./ApiDataSource.vue?vue&type=template&id=f6c09756"
import script from "./ApiDataSource.vue?vue&type=script&lang=js"
export * from "./ApiDataSource.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Eduardo\\Documents\\RadSystems\\PHPRad Projects\\zendata\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__